import React from 'react';
import { Alert, AlertTitle, Typography, Box } from '@mui/material';
import Warning from '@mui/icons-material/Warning';

const WarningAlerts = ({ warning, warningFromVideo, warningKeepOnlyOne }) => {
  return (
    <>
      {warning && (
        <Alert
          severity='warning'
          icon={<Warning sx={{ color: 'white' }} />}
          sx={{
            mt: 2,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: '#9291ef',
            color: 'white',
            fontSize: '0.9rem',
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3,
          }}
        >
          <Box>
            <AlertTitle
              sx={{
                fontWeight: 'bold',
                color: 'white',
                display: 'inline-block',
              }}
            >
              Warning
            </AlertTitle>
            <Typography variant='body2' sx={{ color: 'white' }}>
              You can only edit an existing data entry for this goal on the
              selected day. To add additional data points, please enable the
              option to allow multiple data entries for this goal.
            </Typography>
          </Box>
        </Alert>
      )}

      {warningFromVideo && (
        <Alert
          severity='warning'
          icon={<Warning sx={{ color: 'white' }} />}
          sx={{
            mt: 2,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: '#9291ef',
            color: 'white',
            fontSize: '0.9rem',
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3,
          }}
        >
          <Box>
            <AlertTitle
              sx={{
                fontWeight: 'bold',
                color: 'white',
                display: 'inline-block',
              }}
            >
              Warning
            </AlertTitle>
            <Typography variant='body2' sx={{ color: 'white' }}>
              A data entry for this goal already exists for this video. You can
              only edit the existing entry.
            </Typography>
          </Box>
        </Alert>
      )}

      {warningKeepOnlyOne && (
        <Alert
          severity='warning'
          icon={<Warning sx={{ color: 'white' }} />}
          sx={{
            mt: 2,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: '#9291ef',
            color: 'white',
            fontSize: '0.9rem',
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mb: 3,
          }}
        >
          <Box>
            <AlertTitle
              sx={{
                fontWeight: 'bold',
                color: 'white',
                display: 'inline-block',
              }}
            >
              Warning
            </AlertTitle>
            <Typography variant='body2' sx={{ color: 'white' }}>
              When transitioning from allowing multiple data points per entry to
              allowing only one, you must retain a single data point. Note that
              multiple entries from the same day and for the same subgoal/main
              goal are considered multiple data points.
            </Typography>
          </Box>
        </Alert>
      )}
    </>
  );
};

export default WarningAlerts;
